<script setup lang="ts">
import type { ConvinientSelectProps } from '.';

import Convinient from './Convinient.vue';
import { getConvinientStyles } from './variants';

const props = withDefaults(defineProps<ConvinientSelectProps>(), {
	variant: 'primary'
});

const variantStyles = computed(() => getConvinientStyles(props.variant));
defineEmits<{
	(event: 'update:bedrooms', value: ConvinientSelectProps['bedrooms']): void;
	(event: 'update:suites', value: ConvinientSelectProps['suites']): void;
	(event: 'update:bathrooms', value: ConvinientSelectProps['bathrooms']): void;
	(
		event: 'update:parkingSpots',
		value: ConvinientSelectProps['parkingSpots']
	): void;
}>();

const bedrooms = defineModel<ConvinientSelectProps['bedrooms']>('bedrooms', {
	required: true,
	default: 0
});
const bathrooms = defineModel<ConvinientSelectProps['bathrooms']>('bathrooms', {
	required: true,
	default: 0
});
const suites = defineModel<ConvinientSelectProps['suites']>('suites', {
	required: true,
	default: 0
});
const parkingSpots = defineModel<ConvinientSelectProps['parkingSpots']>(
	'parkingSpots',
	{
		required: true,
		default: 0
	}
);
</script>

<template>
	<div class="w-full space-y-5">
		<p :class="variantStyles.title">Cômodos</p>
		<Convinient
			v-model="bedrooms"
			convinient="bedrooms"
			:variant="props.variant"
		/>
		<Convinient v-model="suites" convinient="suites" :variant="props.variant" />
		<Convinient
			v-model="bathrooms"
			convinient="bathrooms"
			:variant="props.variant"
		/>
		<Convinient
			v-model="parkingSpots"
			convinient="parkingSpots"
			:variant="props.variant"
		/>
	</div>
</template>
